import { render, staticRenderFns } from "./receivable.vue?vue&type=template&id=49b85574&scoped=true&"
import script from "./receivable.vue?vue&type=script&lang=js&"
export * from "./receivable.vue?vue&type=script&lang=js&"
import style0 from "./receivable.vue?vue&type=style&index=0&id=49b85574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b85574",
  null
  
)

export default component.exports